import { graphql } from "~/gql";

export const GET_TAX_INFO_FOR_MATTER = graphql(/* GraphQL */ `
  query GetTaxInfoForMatter($matterId: Int!) {
    getTaxInfoForMatter(matterId: $matterId) {
      taxLabel
      taxLevelPercent
    }
  }
`);
